module.exports = __webpack_public_path__ + "img/C.a9e3a1b5.jpg";